import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-proposals.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Engaging Proposals";

const Proposals = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <figure className={clsx(styles.timelineFigure)}>
          <div className="mx-auto xs:w-3/4 md:w-[150%] md:ml-[-10%]">
            <Image
              src={FigureImage}
              alt="Impress solar customers with Optimus, our stunning, interactive solar proposal tool that’s setting a new industry standard."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
        <TimelineContent
          title={title}
          description="Our sales proposal tool, Optimus, is quickly becoming the new industry standard with first-ever features and a stunning, interactive experience your customers will love. Unify your sales experience with a superior proposal tool, regardless of which design tool or installer(s) you use."
          offsetFigure
          icon={
            <Image
              src="/images/icons/proposals.svg"
              alt="Icon - Enerflo Proposals"
              layout="responsive"
              height={67}
              width={65}
              quality={100}
              className="crispImage"
            />
          }
        />
      </div>
    </HeroSection>
  </div>
);

export default Proposals;
